import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { CommonLocale, ConversationTemplateLocale, ConversationLocale } from "@/locales/localeid";
import TemplateState from "@/modules/conversation-template";
import { AccessLevel, BuilderPageType } from "@/util/enum";
import { Paths } from "@/util/paths";
import { ActionItem, fmtMsg, GLUtil } from "commonui";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Icon, Modal } from "ant-design-vue";
import { ConversationBuilderService } from "@/services/conversation-builder";
import { disabledDueToAccessLevel, getRouteAccessLevel, showErrorMessage } from "@/util/func";
import PageTitle from "@/components/page-title/page-title.vue";

@Component({
	components: {
		Grid,
		ActionItem,
		Icon,
		Modal,
		PageTitle
	}
})
export default class Conversations extends Vue {
	public commonLocale = CommonLocale;
	public newPageUrl = GLUtil.pathStringify(Paths.MasterConversationBuilder, {
		pagetype: BuilderPageType.MasterInfo
	});

	public conversationsStore = getModule(TemplateState);
	public deleting = false;
	public accessLevel = AccessLevel;

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	public get conversations() {
		return this.conversationsStore.conversations;
	}

	get conversationLocale(): any {
		return ConversationLocale;
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	public editPageUrl(id: string): string {
		return GLUtil.pathStringify(Paths.MasterConversationBuilder, {
			pagetype: BuilderPageType.MasterInfo,
			id
		});
	}

	public onDelete(templateId: number) {
		// handle master conversation deletion
		const onOk = async () => {
			this.deleting = true;
			try {
				await ConversationBuilderService.deleteConversation({
					conversationId: this.conversations.find((f) => f.id === templateId)?.conversationId as number,
					masterId: templateId
				});
				this.conversationsStore.setConversations(this.conversations.filter((f) => f.id !== templateId));
				this.deleting = false;
			} catch ({ error_code, error_description }) {
				showErrorMessage(
					{ error_code, error_description },
					fmtMsg(CommonLocale.CommonContentConversationAssociationDeleteMessage)
				);
				this.deleting = false;
			}
		};

		Modal.confirm({
			onOk,
			okText: fmtMsg(ConversationTemplateLocale.TemplateDeleteTxt),
			cancelButtonProps: { props: { disabled: this.deleting } },
			title: fmtMsg(ConversationTemplateLocale.TemlateConversationDelWarn)
		});
	}
}
